import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { UncontrolledTooltip, Table, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { BsFillFileBarGraphFill, BsChatLeftTextFill, BsFilePdfFill } from 'react-icons/bs';
import { Icon } from "./Icon";
import { AppContext } from './../AppContext';
import { Paginacion } from './Paginacion';
import { UnidadConsulta } from './UnidadConsulta';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const TITLE = "Reportes de Retroalimentación Estudiantil";
const APIURL = process.env.REACT_APP_API_URL;

const MySwal = withReactContent(Swal)

const UnidadParalelos = (props) => {

    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);

    const [state, setState] = useState({
        unidad: "",
        anio: 0,
        termino: "",
        nombres: "",
        apellidos: "",
        page: 1,
        size: 10,
        unidades: [],
        anios: [],
        terminos: [],
    });

    const [paralelos, setParalelos] = useState([]);

    const [periodos, setPeriodos] = useState([]);

    const currentUser = useContext(AppContext).currentUser;

    const populateInitialData = async (user) => {
        const unidadesRol = user.roles.filter(r => r.role === "DECANO" || r.role === "SUBDECANO").map(r => r.scope);

        if (unidadesRol.length === 0) return;

        const initialUnidad = props.match.params["unidad"] || unidadesRol[0];

        const initialAnios = []
        let initialPeriodos = []

        if (periodos.length === 0) {
            const responsePeriodos = await fetch(`${APIURL}/api/reporte-usuario/paralelos-unidad-periodos/${initialUnidad}`);
            const dataPeriodos = await responsePeriodos.json();

            initialPeriodos = [...initialPeriodos, ...dataPeriodos.datos];

            initialPeriodos.forEach(at => {
                if (!initialAnios.includes(at.anio)) {
                    initialAnios.push(at.anio);
                }
            });
        }

        const initialAnio = props.match.params["anio"] || (initialAnios.length > 0 ? initialAnios[0] : 0);
        const initialTerminos = []

        initialPeriodos.filter(p => p.anio === initialAnio).forEach(at => {
            if (!initialTerminos.includes(at.termino)) {
                initialTerminos.push(at.termino);
            }
        });
        if (!initialTerminos.includes('2S')) {
            initialTerminos.push('2S');
        }

        const initialTermino = props.match.params["termino"] || (initialTerminos.length > 0 ? initialTerminos[0] : "");
        const initialPage = props.match.params["page"] || state.page;
        const initialSize = props.match.params["size"] || state.size;

        props.history.push(`/paralelos-unidad/${initialUnidad}/${initialAnio}/${initialTermino}/${initialPage}/${initialSize}`);
        setState(prevState => ({
            ...prevState, unidades: unidadesRol, anios: initialAnios, terminos: initialTerminos,
            unidad: initialUnidad, anio: initialAnio, termino: initialTermino
        }));

    }

    const populateData = async (user) => {
        const unidad = props.match.params["unidad"] || state.unidad;
        let anio = props.match.params["anio"] || state.anio;
        let termino = props.match.params["termino"] || state.termino;

        const page = parseInt(props.match.params["page"]) || state.page;
        const size = parseInt(props.match.params["size"]) || state.size;

        if (anio == 0 || unidad === "" || termino === "") return;

        const nombres = state.nombres;
        const apellidos = state.apellidos;

        let apiUrl = `${APIURL}/api/reporte-usuario/paralelos-unidad/${unidad}/${anio}/${termino}/${page}/${size}`;
        if (nombres && nombres.trim() !== "") {
            apiUrl += `/${encodeURIComponent(nombres.trim())}`;
        }
        if (apellidos && apellidos.trim() !== "") {
            if (!nombres || nombres.trim() === "") apiUrl += `/${encodeURIComponent(" ")}`;
            apiUrl += `/${encodeURIComponent(apellidos.trim())}`;
        }

        const response = await fetch(apiUrl);
        const data = await response.json();

        setLoading(false);
        if (data && data.total && data.datos) {
            setParalelos(data.datos.map(p => ({ ...p, verpdf: false, datapdf: "" })));
            setTotal(data.total);
        } else {
            setParalelos([]);
            setTotal(0);
        }
    };

    useEffect(() => {
        document.title = TITLE + " - Profesores de mi unidad";
        if (currentUser && currentUser !== undefined) {
            populateInitialData(currentUser);
        }
    }, [currentUser]);

    useEffect(() => {
        if (currentUser && currentUser !== undefined) {
            setLoading(true);
            populateData(currentUser);
        }
    }, [state]);

    const handleInputChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        const { unidad, anio, termino } = state;
        const page = 1;
        const size = 10;

        if (name === "unidad") {
            props.history.push(`/paralelos-unidad/${value}/${anio}/${termino}/${page}/${size}`);
            setState({ ...state, unidad: value, nombres: "", apellidos: "", page: page, size: size });
        } else if (name === "anio") {
            props.history.push(`/paralelos-unidad/${unidad}/${value}/${termino}/${page}/${size}`);
            setState({ ...state, anio: value, nombres: "", apellidos: "", page: page, size: size });
        } else if (name === "termino") {
            props.history.push(`/paralelos-unidad/${unidad}/${anio}/${value}/${page}/${size}`);
            setState({ ...state, termino: value, nombres: "", apellidos: "", page: page, size: size });
        }
    };


    const handleDocenteInput = (apellidos, nombres) => {
        const { unidad, anio, termino } = state;
        props.history.push(`/paralelos-unidad/${unidad}/${anio}/${termino}/${1}/${10}`);
        setState({
            ...state,
            apellidos: apellidos == null ? "" : apellidos.trim(),
            nombres: nombres == null ? "" : nombres.trim(),
            page: 1, size: 10
        });
    };

    const handlePage = (url, page, size) => {
        props.history.push(`${url}/${page}/${size}`);
        setState({ ...state, page: page, size: size });
    };

    const toggle = (paralelo) => {
        const i = paralelos.indexOf(paralelo);

        if (!paralelo.verpdf) {
            MySwal.showLoading();
            fetch(`${APIURL}/api/reporte-usuario/reporte-general-pdf/${paralelo.sistema}/${paralelo.idcurso}/${paralelo.idpersona}`)
                .then(response => response.json())
                .then(data => {
                    MySwal.close();
                    setParalelos(prevParalelos => [
                        ...prevParalelos.slice(0, i),
                        {
                            ...prevParalelos[i],
                            verpdf: !prevParalelos[i].verpdf,
                            datapdf: data
                        },
                        ...prevParalelos.slice(i + 1)
                    ]);
                });
        } else {
            setParalelos(prevParalelos => [
                ...prevParalelos.slice(0, i),
                {
                    ...prevParalelos[i],
                    verpdf: !prevParalelos[i].verpdf,
                },
                ...prevParalelos.slice(i + 1)
            ]);
        }
    };

    const formatter = (valor) => {
        return new Intl.NumberFormat('en-US', { minimumFractionDigits: '2', maximumFractionDigits: '2', signDisplay: 'never' }).format(valor);
    };

    const renderTable = (paralelos) => {
        return (
            <Table responsive={true} striped={true}>
                <thead>
                    <tr>
                        <th className="text-center col-1" scope="col">Año</th>
                        <th className="text-center col-1" scope="col">Término</th>
                        <th className="text-center col-1" scope="col">Nivel</th>
                        <th className="text-center col-1" scope="col">Código</th>
                        <th className="text-center col-1" scope="col">Materia</th>
                        <th className="text-center col-1" scope="col">Paralelo</th>
                        <th className="text-center col-2" scope="col">Docente</th>
                        <th className="text-center col-1" scope="col">% Respuestas</th>
                        <th className="text-center col-1" scope="col">Calificación</th>
                        <th className="text-center col-2" scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    {paralelos.map((p, index) => {
                        const porcentaje = Math.round(p.evaluados * 100 / p.registrados);
                        return (
                            <tr key={index}>
                                <td className="text-center">{p.anio}</td>
                                <td className="text-center">{p.termino}</td>
                                <td className="text-center">{p.nivel}</td>
                                <td className="text-center">{p.codigo}</td>
                                <td>{p.materia}</td>
                                <td className="text-center">{p.paralelo}</td>
                                <td>{p.apellidos} {p.nombres}</td>
                                <td className="text-center">
                                    <span id={"tt_" + index}>{porcentaje}%</span>
                                    <UncontrolledTooltip placement="right" target={"tt_" + index}>
                                        {p.evaluados}/{p.registrados}
                                    </UncontrolledTooltip>
                                </td>
                                <td className="text-center">{formatter(p.promedio)}</td>
                                <td>
                                    <div className="btn-group" role="group" aria-label="Opciones">
                                        <span id={"ttb_" + index}>
                                            <Link className="btn btn-secondary btn-sm" to={`/paralelo/${p.anio}/${p.termino}/${p.codigo}/${p.paralelo}/${p.cedula}`}>
                                                <Icon icon={<BsFillFileBarGraphFill />} />
                                            </Link>
                                        </span>
                                        <UncontrolledTooltip placement="top" target={"ttb_" + index}>
                                            {"Detalle"}
                                        </UncontrolledTooltip>
                                        <span id={"ttb_pdf_" + index}>
                                            <Link className="btn btn-secondary btn-sm" to="#" onClick={() => toggle(p)}>
                                                <Icon icon={<BsFilePdfFill />} />
                                            </Link>
                                        </span>
                                        <UncontrolledTooltip placement="top" target={"ttb_pdf_" + index}>
                                            {"Detalle en PDF"}
                                        </UncontrolledTooltip>
                                        <Modal isOpen={p.verpdf} className="modal-xl">
                                            <ModalHeader>Detalle Paralelo</ModalHeader>
                                            <ModalBody>
                                                <embed src={`data:application/pdf;base64,${p.datapdf}`} width={1100} height={600} type='application/pdf' pluginspage="http://www.adobe.com/products/acrobat/readstep2.html" />
                                            </ModalBody>
                                            <ModalFooter>
                                                <Button color="secondary" onClick={() => toggle(p)}>Cerrar</Button>
                                            </ModalFooter>
                                        </Modal><br />
                                        <span id={"ttc_" + index}>
                                            <Link className="btn btn-secondary btn-sm" to={`/paralelo-comentarios/${p.anio}/${p.termino}/${p.codigo}/${p.paralelo}/${p.cedula}/${p.idnivelformacion}`}>
                                                <Icon icon={<BsChatLeftTextFill />} />
                                            </Link>
                                        </span>
                                        <UncontrolledTooltip placement="top" target={"ttc_" + index}>
                                            {"Comentario"}
                                        </UncontrolledTooltip>
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan={8}>
                            <Paginacion total={total} page={state.page} size={state.size} url={`/paralelos-unidad/${state.unidad}/${state.anio}/${state.termino}`} handle={handlePage} />
                        </td>
                    </tr>
                </tfoot>
            </Table>
        );
    };

    const contents = loading ? <p><em>Loading...</em></p> : renderTable(paralelos);

    return (
        <div>
            <h1 id="tabelLabel">Docentes de mi unidad</h1>
            <UnidadConsulta
                unidadOptions={state.unidades}
                unidadValue={state.unidad}
                anioOptions={state.anios}
                anioValue={state.anio}
                terminoOptions={state.terminos}
                terminoValue={state.termino}
                onInputChange={handleInputChange}
                handleDocenteSubmit={handleDocenteInput}
            />
            {contents}
        </div>
    );
};

export default UnidadParalelos;